import { useTheme } from '@mui/material/styles';

interface CaretDownProps {
  width?: number;
  height?: number;
  className?: string;
  strokeColor?: string;
}

export default function CaretDown({ width = 24, height = 25, className, strokeColor }: CaretDownProps) {
  const theme = useTheme();
  const defaultStrokeColor = theme.palette.text.primary;
  const finalStrokeColor = strokeColor || defaultStrokeColor;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 25"
      fill="none"
      className={className}
    >
      <path
        d="M19 9.5L12.7071 15.7929C12.3166 16.1834 11.6834 16.1834 11.2929 15.7929L5 9.5"
        stroke={finalStrokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
